import React from "react";
import makeStyles from "@mui/styles/makeStyles";
import { TableRow, TableCell, TextField } from "@mui/material";
import { Search } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import moment from "moment";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";

const useStyles = makeStyles(theme => ({
  cell: {
    position: "sticky",
    top: theme.spacing(6),
    zIndex: "10",
    padding: 0,
    border: "none",
    backgroundColor: theme.palette.table.filterRow,
    "&:after": {
      content: `''`,
      position: "absolute",
      left: 0,
      bottom: 0,
      width: "100%",
      borderBottom: `solid 1px ${theme.palette.divider}`
    }
  },
  filter: {
    margin: theme.spacing(1, 3, 1, 0),
    maxHeight: theme.spacing(4),
    background: theme.palette.common.white
  }
}));

const DateFilter = ({ onFilterChanged, columnDef, isResetFilters }) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const value =
    !columnDef.tableData.filterValue || isResetFilters
      ? null
      : columnDef.tableData.filterValue;

  return (
    <LocalizationProvider dateAdapter={AdapterMoment}>
      <DatePicker
        clearable
        value={value}
        onChange={date => {
          // Only changes the filter if the date is valid or empty
          if (moment(date).isValid() || !date) {
            onFilterChanged(columnDef.tableData.id, date);
          }
        }}
        error={null}
        helperText={null}
        renderInput={params => (
          <TextField
            variant="filled"
            {...params}
            InputProps={{
              disableUnderline: true,
              className: classes.filter,
              hiddenLabel: true,
              ...params.InputProps
            }}
            inputProps={{
              ...params.inputProps,
              placeholder: columnDef.filterPlaceholder
                ? t("table.filterPlaceholder." + columnDef.filterPlaceholder)
                : ""
            }}
          />
        )}
      />
    </LocalizationProvider>
  );
};

const TextFieldFilter = ({ onFilterChanged, columnDef, isResetFilters }) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const value =
    !columnDef.tableData.filterValue || isResetFilters
      ? ""
      : columnDef.tableData.filterValue;
  return (
    <TextField
      fullWidth
      value={value}
      placeholder={
        columnDef.filterPlaceholder
          ? t("table.filterPlaceholder." + columnDef.filterPlaceholder)
          : ""
      }
      onChange={event => {
        onFilterChanged(columnDef.tableData.id, event.target.value);
      }}
      variant="filled"
      InputProps={{
        disableUnderline: true,
        endAdornment: <Search color="action" />,
        className: classes.filter
      }}
      hiddenLabel
    />
  );
};

function FilterRow(props) {
  const classes = useStyles();
  function getFilterInputBox(columnDef) {
    if (columnDef.options && columnDef.options.filtering) {
      if (columnDef.options.filterType === "date") {
        return (
          <DateFilter
            onFilterChanged={props.onFilterChanged}
            columnDef={columnDef}
            isResetFilters={props.isResetFilters}
          />
        );
      } else {
        return (
          <TextFieldFilter
            onFilterChanged={props.onFilterChanged}
            columnDef={columnDef}
            isResetFilters={props.isResetFilters}
          />
        );
      }
    } else {
      return null;
    }
  }

  let columns = props.columns.map((columnDef, index) => (
    <TableCell key={columnDef.tableData.id} classes={{ root: classes.cell }}>
      {getFilterInputBox(columnDef)}
    </TableCell>
  ));
  if (props.selection) {
    columns.splice(
      0,
      0,
      <TableCell padding={"none"} key={"key-selection-column"} />
    );
  }

  return <TableRow classes={{ root: classes.root }}>{columns}</TableRow>;
}

export default FilterRow;
